import React from 'react';
import ReactDOM from 'react-dom/client';
// React 19 compatibility shim for antd v5's static methods (Modal.confirm,
// message.x, notification.x). Without this they silently no-op under React 19.
// See: https://ant.design/docs/react/v5-for-19
import '@ant-design/v5-patch-for-react-19';
import './index.css';
import './fonts/sofia-pro.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
